export const lightBlue50 = "#eaf3ff";
export const lightBlue100 = "#dcefff";
export const lightBlue200 = "#b9dfff";
export const lightBlue300 = "#97d0ff";
export const lightBlue400 = "#74c0ff";
export const lightBlue500 = "#52b1ff";
export const lightBlue600 = "#4499ff";
export const lightBlue700 = "#3681ff";
export const lightBlue800 = "#286aff";
export const lightBlue900 = "#1a52ff";
export const lightBlue1000 = "#021aff";
export const lightBlueA100 = "#93efff";
export const lightBlueA200 = "#7bd8ff";
export const lightBlueA400 = "#298aff";
export const lightBlueA500 = "#064cff";
export const lightBlueA1000 = "#1c3d59";
